import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/news-new';
import {apiback} from '../../../config';
import buildUrl from '../../../helpers/utils/buildGetURLWithParams';

const NEWS_PER_PAGE = 3;

export default class extends View {
    template = tpl;

    myRef = React.createRef();

    state = {
        news: [],
        limit: NEWS_PER_PAGE,
        offset: 0,
        isMobile: window.innerWidth < 500
    };

    updateWidth = () => {
        this.setState({isMobile: window.innerWidth < 500});
    };

    getNews = () => {
        const {offset, limit} = this.state;
        const params = {
            offset,
            limit,
            sort_by: ['date'],
            order_by: ['DESC']
        };

        const url = buildUrl(apiback('API_NEWS'), params);
        fetch(url)
            .then(res => res.json())
            .then(({data}) => {
                if (data) {
                    this.setState({news: data});
                }
            });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateWidth);
        this.getNews();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWidth);
    }

    static displayName = 'News.List';
}
